import { INIT_SPID_ERROR, INIT_SPID_START, INIT_SPID_SUCCESS, INIT_SPID_RESET } from "../actions/initspid";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export function initSpid(state = defaultState, { type, payload, error }) {
    switch (type) {
        case INIT_SPID_START:
            return {
                ...defaultState,
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case INIT_SPID_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                payload
            };
        case INIT_SPID_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        case INIT_SPID_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
